export default __webpack_public_path__ + "static/media/Vogel-auf-Früchtekorb.fc71a860.png";